import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { ErgonomicWorkAnalysisKeyResultService } from '@/infra/services/ergonomic-work-analysis-key-result';
import { QUERY_KEYS } from '@/utils/query-keys';

interface CreateEWAStepKeyResultsParams {
	organization_id: string;
	company_id: string;
	ergonomic_work_analysis_id: string;
	custom_report_result_ids: string[];
	custom_report_step_key_ids: string[];
	custom_report_step_ids?: string[];
	select_all_step_keys?: boolean;
}

const Service = ErgonomicWorkAnalysisKeyResultService.getInstance();

export const useCreateEWAStepKeyResults = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (params: CreateEWAStepKeyResultsParams) => Service.bulkCreate(params),
		onSuccess: () => {
			queryClient.invalidateQueries([QUERY_KEYS.GET_EWA_SELECTED_STEP_KEY_RESULTS]);
		},
		onError: () => {
			message.error(I18n.get('Ops... something happened!'));
		}
	});
};
